import * as types from "./rootMutationNames"

const mutations = {
    [types.UPDATE_QUIZ_STARTED](state,payload) {
        state.quizStarted = payload;
        state.numQuestionsAnswered =  Object.keys(state.selectedOptions).length;
    },

    [types.UPDATE_NUM_QUESTIONS](state,payload) {
        state.numQuestions = payload;
    },

    [types.UPDATE_SELECTION](state,payload){
        if(payload.optionType==="m"){
            payload.optionId = payload.optionId.filter(item => item !== null);
        }

        state.selectedOptions[payload.questionId] = payload.optionId;

        state.numQuestionsAnswered = Object.keys(state.selectedOptions).length;
    },

    [types.ADD_VIDEOS_WATCHED](state, payload) {
        state.videosWatched[payload] = true;
    },
    
    [types.UPDATE_QUIZ_FINISHED](state, payload) {
        state.quizFinished = payload;
    },

    [types.UPDATE_QUIZ_PASSED](state, payload) {
        state.quizPassed = payload;
    },
    
    [types.UPDATE_WRONG_ANSWERS_COUNT](state, payload) {
        state.wrongAnswersCount = payload;
    },
    
    [types.UPDATE_RETURN_URL](state, payload) {
        state.returnUrl = payload;
    },

    [types.RETRY_QUIZ](state) {
        state.quizFinished = false;
        state.quizStarted = false,
        state.quizFinished = false;
    },

    [types.RESET](state, payload) {
        state.videosWatched = {};
        state.slug = payload;
        state.selectedOptions = {};
        state.quizStarted = false;
        state.numQuestionsAnswered = 0;
    }
}

export default mutations